import type { HTMLAttributes } from 'react';

/** Native links support copy/middle-click, while ordinary clicks still pass through the shared dirty guard. */
export function ChatHistoryTarget({
  href,
  onClick,
  disabled,
  type,
  ...props
}: Omit<HTMLAttributes<HTMLElement>, 'onClick'> & {
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button';
}) {
  if (!href || disabled) return <button {...props} type={type ?? 'button'} disabled={disabled} onClick={onClick} />;
  return (
    <a
      {...props}
      href={href}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        onClick?.();
      }}
    />
  );
}
